import React from "react";
import {useField, useFormikContext} from "formik";
import TextField from "@mui/material/TextField";
import {stripDoubleQuotes} from "../stripDoubleQuotes";

/**
 * A Material-UI TextField component connected to Formik state.
 *
 * Will display `tiptext` if it is set, otherwise it will display an error message if the field is touched.
 *
 * @param {string} formikKey - The key to the Formik state to connect to.
 * @param {object} props - Additional props to be spread onto the TextField component.
 * @param {string} props.tiptext - The text to display in place of an error message.
 *
 * @returns {React.ReactElement} The connected TextField component.
 */
export const FormikTextField = ({formikKey, ...props}) => {
    const {setFieldValue} = useFormikContext();
    const [field, meta] = useField(formikKey);

    const helperTextOrErrorText = typeof (meta.error) !== 'undefined' ? meta.error : props.helperText;

    if (undefined === meta.initialValue) {
        return null;
    } else {
        return (
            <TextField
                id={field.name}
                key={field.name}
                name={field.name}
                variant={"outlined"}
                error={meta.touched && Boolean(meta.error)}
                value={field.value}
                onChange={event => {
                    setFieldValue(field.name, stripDoubleQuotes(event.target.value));
                }}
                onBlur={field.onBlur}
                {...{...props, helperText: helperTextOrErrorText}}
            />
        );
    }
};
